export const HELPFILENAME = 'Velocity_Web_Services_Client_User_Guide_v_3.8.6.103.pdf';

